var React = require('react');

function Star (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M29.9 12.16a2 2 0 0 0-1.73-1.37l-7.42-.64-2.91-6.92a2 2 0 0 0-3.68 0l-2.9 6.92-7.43.64a2 2 0 0 0-1.14 3.5l5.64 4.94-1.7 7.31a2 2 0 0 0 2.99 2.17l6.37-3.88 6.39 3.88a2 2 0 0 0 2.98-2.17l-1.69-7.32 5.64-4.92a2 2 0 0 0 .59-2.14Zm-1.9.63-5.64 4.92a2 2 0 0 0-.63 1.96L23.42 27l-6.38-3.88a1.99 1.99 0 0 0-2.07 0L8.59 27l1.69-7.32a2 2 0 0 0-.64-1.97L4 12.8l7.43-.65a2 2 0 0 0 1.67-1.22L16 4.01l2.9 6.91a2 2 0 0 0 1.67 1.22l7.43.64v.01Z"}));
}

Star.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = Star;

Star.default = Star;
